"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1() {
    window.location.href = '/room/room_create_new/';
}
exports.default = default_1;
